import axios from 'axios';
import { fetchWithCache } from './apiConfig';

export const getMagicCraftListedNfts = async (
  pageNumber: number,
  sortField: string,
  contractAddress: string,
  filter: number,
  rarity?: string[],
  account?: string,
) => {
  const url = `${process.env.REACT_APP_MARKETPLACE_BACK_URL}/auction`;
  const params = {
    contractAddress,
    page: pageNumber,
    sortField,
    filter,
    ...(account && { address: account.toLowerCase() }),
    ...(rarity && rarity.length > 0 && { rarity: rarity.toString() })
  };
  
  // Use cached API call with 5 minute cache time
  const data = await fetchWithCache(url, params, 5 * 60 * 1000);
  
  if (data && data.items.length === 0) return [];
  return data.items;
};

export const getMagicCraftNfts = async (
  contractAddress: string | undefined,
  ids: Array<String>,
) => {
  let { data } = await axios.post(
    `${process.env.REACT_APP_MARKETPLACE_BACK_URL}/getNFT`,
    {
      contractAddress,
      ids: ids,
    },
  );

  if (!data || !data.items || data.items.length === 0) return [];

  const holders = data.holders || [];
  data.items = data.items.map((it: any) => {
    const holderObj = holders.find(
      (holder: any) => holder?.tokenID == it?.tokenID,
    );
    const ownerAddr = holderObj?.holder;
    return { ...it, owner: ownerAddr };
  });

  return data.items;
};

export const getMagicCraftAccountWithNfts = async (
  pageNumber: number,
  sortField: string,
  contractAddress: string,
  filter: number,
  account: string,
  rarity?: string[],
) => {
  let { data } = await axios.post(
    `${process.env.REACT_APP_MARKETPLACE_BACK_URL}/getNFT`,
    {
      address: account,
    },
  );

  let listedData = await getMagicCraftListedNfts(
    pageNumber,
    sortField,
    contractAddress,
    filter,
    rarity,
    account,
  );

  let listedMeta = await getMagicCraftNfts(
    contractAddress,
    listedData.map((it: any) => it.tokenID),
  );

  for (let i = 0; i < listedData.length; i++) {
    let metadata = listedMeta.find(
      (it: any) => it.tokenID == listedData[i].tokenID,
    );
    listedData[i].name = metadata.name;
    listedData[i].description = metadata.description;
    listedData[i].image = metadata.image;
    listedData[i].attributes = [...metadata.attributes];
  }

  if (data && data.items.length === 0 && listedData.length == 0) return [];

  return [...listedData, ...data.items];
};
